import { Overlay, ImageItem } from "@albelli/image-list-view"
import { SelectionManager, SelectionListener, SelectionAction, PhotoItem } from "@albelli/photoselector"

import "./Selection.css"

export function makeSelectionOverlay(store: SelectionManager, bulkSelectAdapter?: () => PhotoItem[]): Overlay {
  function renderSelection() {
    const selection = document.createElement("div")
    selection.classList.add("photoselector-selection-overlay")
    selection.setAttribute("data-tam", "selection-overlay")
    return selection
  }

  return (image: ImageItem, img: HTMLDivElement) => {
    const item = image as PhotoItem
    let selectionView: HTMLElement | null

    const setVisualState = (shouldSelect: boolean) => {
      if (shouldSelect && !selectionView) {
        selectionView = renderSelection()
        img.appendChild(selectionView)
      } else if (!shouldSelect && selectionView) {
        img.removeChild(selectionView)
        selectionView = null
      }
    }

    const onStoreUpdate: SelectionListener = (action: SelectionAction) => {
      if (action === "select" || action === "select_list") {
        const selected = store.isSelected(item)
        selected && setVisualState(selected)
      } else if (action === "deselect") {
        const deselected = !store.isSelected(item)
        deselected && setVisualState(false)
      } else if (action === "set") {
        setVisualState(store.isSelected(item))
      }
    }

    const clickListener = (ev: MouseEvent) => {
      if (bulkSelectAdapter && ev.shiftKey) {
        store.rangeSelect(item, bulkSelectAdapter())
      } else if (selectionView) {
        store.deselect(item)
      } else {
        store.select(item)
      }
      ev.stopImmediatePropagation()
    }

    setVisualState(store.isSelected(item))
    store.addListener(onStoreUpdate)
    img.addEventListener("click", clickListener)

    return () => {
      store.removeListener(onStoreUpdate)
      img.removeEventListener("click", clickListener)
      setVisualState(false)
    }
  }
}
